import { render, staticRenderFns } from "./ClaimsSectionInvoice.vue?vue&type=template&id=06c8e6c4&scoped=true&"
import script from "./ClaimsSectionInvoice.vue?vue&type=script&lang=js&"
export * from "./ClaimsSectionInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ClaimsSectionInvoice.vue?vue&type=style&index=0&id=06c8e6c4&lang=styl&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c8e6c4",
  null
  
)

export default component.exports